export interface IEUserData extends HTMLInputElement {
  save(name: string): void
  load(name: string): void
  expires: string
  addBehavior(arg0: string): void
}
export interface UserStore {
  userData: IEUserData | null
  name: string
  init: () => boolean
  setItem(key: string, value: string): void
  getItem(key: string): string
  removeItem(key: string): void
}

const userStore: UserStore = {
  userData: null,
  name: `${location.hostname}_snaker`,
  init () {
    if (!userStore.userData) {
      try {
        userStore.userData = document.createElement('INPUT') as IEUserData
        userStore.userData.type = 'hidden'
        userStore.userData.style.display = 'none'
        userStore.userData.addBehavior('#default#userData')
        userStore.userData && document.body.appendChild(userStore.userData)

        const expires = new Date()
        expires.setDate(expires.getDate() + 365)
        userStore.userData.expires = expires.toUTCString()
      } catch (error) {
        console.log('userData is disabled!')
        return false
      }
    }
    return true
  },
  setItem (key, value) {
    if (userStore.init() && userStore.userData) {
      userStore.userData.load(userStore.name)
      userStore.userData.setAttribute(key, value)
      userStore.userData.save(userStore.name)
    }
  },
  getItem (key) {
    if (userStore.init() && userStore.userData) {
      userStore.userData.load(userStore.name)
      return userStore.userData.getAttribute(key) || ''
    }
    return ''
  },
  removeItem (key) {
    if (userStore.init() && userStore.userData) {
      userStore.userData.load(userStore.name)
      userStore.userData.removeAttribute(key)
      userStore.userData.save(userStore.name)
    }
  }
}

export default userStore
